<div pmdModal
    modalTrap
    class="modal pmd-modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="vertically-centered"
    [config]="{ backdrop: 'static' }">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content profile-setup-modal-content">
            <div class="profile-setup-modal-header d-flex justify-content-end align-items-center p-3 p-lg-4">
                <button type="button" class="btn btn-link logout-link d-flex align-items-center gap-2" (click)="onLogout()">
                    <svg width="18" height="16" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.833496 7C0.833496 3.42825 3.62631 0.500239 7.11084 0.5C8.11387 0.5 9.0629 0.743736 9.90381 1.17676L10.2573 1.37402L10.3384 1.43457C10.5099 1.59183 10.5537 1.8533 10.4292 2.06055C10.3048 2.26756 10.0537 2.3517 9.83447 2.27441L9.74268 2.23145L9.44678 2.06641C8.74249 1.70355 7.94953 1.5 7.11084 1.5C4.21382 1.50024 1.8335 3.94463 1.8335 7C1.8335 10.0554 4.21382 12.4998 7.11084 12.5C8.06918 12.5 8.96765 12.2341 9.74268 11.7686L9.83447 11.7256C10.0537 11.6483 10.3048 11.7324 10.4292 11.9395C10.5714 12.1762 10.494 12.4838 10.2573 12.626L9.90381 12.8232C9.06291 13.2563 8.11387 13.5 7.11084 13.5C3.62631 13.4998 0.833496 10.5717 0.833496 7ZM11.647 3.97949C11.8178 3.80896 12.081 3.78806 12.2749 3.91602L12.354 3.97949L15.02 6.64648C15.2153 6.84174 15.2153 7.15825 15.02 7.35352L12.354 10.0205C12.1588 10.2157 11.8423 10.2155 11.647 10.0205C11.4517 9.82525 11.4517 9.50874 11.647 9.31348L13.4595 7.5H6.00049C5.72435 7.5 5.50049 7.27614 5.50049 7C5.50049 6.72386 5.72435 6.5 6.00049 6.5H13.4595L11.647 4.68652L11.5825 4.6084C11.4544 4.41433 11.4761 4.15033 11.647 3.97949Z" fill="black" />
                    </svg>
                    Logout
                </button>
            </div>
            <!-- Modal Body -->
            <div class="modal-body p-0 m-0">
                <div class="row g-0">
                    <div class="col-md-4">
                        <div class="bg-light-gray h-100 rounded-0 border-end p-3 p-lg-4">
                            <p class="text-desc">Complete following steps to setup your profile</p>
                            <div class="khar_wizard">
                                <div class="process py-4">
                                    <ul>
                                        <li class="step {{currentStep == 1 ? 'current' : 'completed'}}">
                                            <div class="name">Personal Info
                                            </div>
                                            <p class="subtitle">Your basic details</p>
                                        </li>
                                        <li
                                            class="step {{currentStep == 2 ? 'current' : currentStep == 3 ? 'completed' : ''}}">
                                            <div class="name">Company Info</div>
                                            <p class="subtitle">Your Company details</p>
                                        </li>
                                        <li class="step {{currentStep == 3 ? 'current' : ''}}">
                                            <div class="name">Complete</div>
                                            <p class="subtitle mb-0">Enjoy Free Trial</p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-8">
                        <form action="#"
                            class="p-3 p-lg-4  pb-lg-3">
                            <div class="personal-info-card"
                                *ngIf="currentStep == 1">
                                <form [formGroup]="personalInfoFormGroup">
                                    <div class="text-secondary-dark fw-bold">Step 1 of 3</div>
                                    <h4 class="text-dark">Personal Info</h4>
                                    <div class="mb-3 mt-4">
                                        <label for="userName"
                                            class="col-form-label">Owner Name <strong class="text-danger">*</strong>
                                        </label>
                                        <pmd-textfield pmd-textfield-outline>
                                            <input name="userName"
                                                formControlName="name"
                                                id="userName"
                                                maxlength="100"
                                                type="text"
                                                class="form-control"
                                                placeholder="Rohan Patel"
                                                pmdTextField
                                                autocomplete="off">
                                        </pmd-textfield>
                                        <div *ngIf="sharedService.hasErrors(fPersonalInfo.name, isSubmitAttemptedForPersonalInfo)"
                                            class="invalid-feedback">
                                            <ng-container *ngIf="fPersonalInfo.name.errors.required">
                                                Owner Name is required.
                                            </ng-container>
                                            <ng-container *ngIf="fPersonalInfo.name.errors.pattern">
                                                Enter a valid Owner Name.
                                            </ng-container>
                                        </div>
                                    </div>
                                    <div class="mb-3">
                                        <label for="email"
                                            class="col-form-label">Email <strong class="text-danger">*</strong>
                                        </label>
                                        <pmd-textfield pmd-textfield-outline>
                                            <input name="email"
                                                formControlName="email"
                                                id="email"
                                                maxlength="100"
                                                type="text"
                                                class="form-control"
                                                pmdTextField
                                                placeholder="rohanpatel@gmail.com"
                                                autocomplete="off"
                                                (keydown)="fPersonalInfo.email.disabled ? $event.preventDefault() : ''" />
                                        </pmd-textfield>
                                        <div *ngIf="sharedService.hasErrors(fPersonalInfo.email, isSubmitAttemptedForPersonalInfo)"
                                            class="invalid-feedback">
                                            <ng-container
                                                *ngIf="fPersonalInfo.email.errors.required || fPersonalInfo.email.errors.pattern">
                                                Enter a valid email id.
                                            </ng-container>
                                        </div>
                                    </div>
                                    <div class="mb-3">
                                        <label for="mobile"
                                            class="col-form-label">Mobile Number <strong class="text-danger">*</strong>
                                        </label>
                                        <pmd-textfield pmd-textfield-outline>
                                            <input name="mobile"
                                                formControlName="mobile"
                                                id="mobile"
                                                maxlength="100"
                                                type="text"
                                                class="form-control"
                                                placeholder="ex: 9909237378"
                                                pmdTextField
                                                autocomplete="off"
                                                (keydown)="fPersonalInfo.mobile.disabled ?  $event.preventDefault() : ''">
                                        </pmd-textfield>
                                        <div *ngIf="sharedService.hasErrors(fPersonalInfo.mobile, isSubmitAttemptedForPersonalInfo)"
                                            class="invalid-feedback">
                                            <ng-container
                                                *ngIf="fPersonalInfo.mobile.errors.required || fPersonalInfo.mobile.errors.pattern">
                                                Enter a valid mobile number
                                            </ng-container>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div class="personal-info-card"
                                *ngIf="currentStep == 2">
                                <form [formGroup]="companyInfoFormGroup">
                                    <div class="text-secondary-dark fw-bold">Step 2 of 3</div>
                                    <h4 class="text-dark">Company Info</h4>

                                    <div class="mb-3 mt-4">
                                        <label for="CompanyName"
                                            class="col-form-label">Company Name <strong class="text-danger">*</strong>
                                        </label>
                                        <pmd-textfield pmd-textfield-outline>
                                            <input name="CompanyName"
                                                formControlName="companyName"
                                                id="CompanyName"
                                                maxlength="100"
                                                type="text"
                                                class="form-control"
                                                placeholder="ex: Rich Elements Ltd"
                                                pmdTextField
                                                autocomplete="off">
                                        </pmd-textfield>
                                        <div *ngIf="sharedService.hasErrors(fCompanyInfo.companyName, isSubmitAttemptedForCompanyInfo)"
                                            class="text-danger">
                                            <div *ngIf="fCompanyInfo.companyName.errors.required">Company Name is
                                                required.
                                            </div>
                                            <div *ngIf="fCompanyInfo.companyName.errors.pattern">Invalid company name.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mb-3">
                                        <label for="GSTNumber"
                                            class="col-form-label">GST Number
                                        </label>
                                        <pmd-textfield pmd-textfield-outline>
                                            <input name="GSTNumber"
                                                formControlName="gst"
                                                id="GSTNumber"
                                                maxlength="100"
                                                type="text"
                                                class="form-control"
                                                pmdTextField
                                                placeholder="ex: 24BMDAM9828Z3Z1"
                                                autocomplete="off"
                                                (keyup)="onGSTAdd()"
                                                (change)="onGSTAdd()">
                                        </pmd-textfield>
                                        <div *ngIf="sharedService.hasErrors(fCompanyInfo.gst, isSubmitAttemptedForCompanyInfo)"
                                            class="text-danger">
                                            <div *ngIf="fCompanyInfo.gst.errors.pattern">Invalid GST Number.</div>
                                        </div>
                                    </div>
                                    <div class="mb-3">
                                        <label for="PAN"
                                            class="col-form-label">PAN <strong class="text-danger">*</strong>
                                        </label>
                                        <pmd-textfield pmd-textfield-outline>
                                            <input name="PAN"
                                                formControlName="pan"
                                                id="PAN"
                                                maxlength="100"
                                                type="text"
                                                class="form-control"
                                                placeholder="ex: MDAM9828Z"
                                                pmdTextField
                                                autocomplete="off">
                                        </pmd-textfield>
                                        <div *ngIf="sharedService.hasErrors(fCompanyInfo.pan, isSubmitAttemptedForCompanyInfo)"
                                            class="text-danger">
                                            <div *ngIf="fCompanyInfo.pan.errors.required">PAN is required.</div>
                                            <div *ngIf="fCompanyInfo.pan.errors.pattern">Invalid PAN.</div>
                                            <div *ngIf="fCompanyInfo.pan.errors?.PANNotMatching">PAN does not match with
                                                GST Number.</div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div class="personal-info-card"
                                *ngIf="currentStep == 3">
                                <div class="text-secondary-dark fw-bold">Step 3 of 3</div>
                                <h4 class="text-dark">10 Days Free Trial</h4>
                                <p class="mb-0">Welcome to Purchase by Petpooja. Your 10 days free trial has started.
                                </p>
                                <p>Please keep in mind, the features listed below will be available only after
                                    purchasing the premium plan.</p>
                                <div class="d-flex gap-3 justify-content-between text-center py-3">
                                    <div class="card-list-circle mb-2">
                                        <div class="rounded-img"><svg width="31"
                                                height="31"
                                                viewBox="0 0 31 31"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M6.50098 11.7499V21.7499M12.126 11.7499V21.7499M18.376 11.7499V21.7499M24.001 11.7499V21.7499M4.00098 23.7499L4.00098 24.7499C4.00098 25.45 4.00098 25.8 4.13722 26.0674C4.25706 26.3026 4.44829 26.4938 4.68349 26.6137C4.95088 26.7499 5.30091 26.7499 6.00098 26.7499H24.501C25.201 26.7499 25.5511 26.7499 25.8185 26.6137C26.0537 26.4938 26.2449 26.3026 26.3647 26.0674C26.501 25.8 26.501 25.45 26.501 24.7499V23.7499C26.501 23.0498 26.501 22.6998 26.3647 22.4324C26.2449 22.1972 26.0537 22.006 25.8185 21.8861C25.5511 21.7499 25.201 21.7499 24.501 21.7499H6.00098C5.30091 21.7499 4.95088 21.7499 4.68349 21.8861C4.44829 22.006 4.25706 22.1972 4.13722 22.4324C4.00098 22.6998 4.00098 23.0498 4.00098 23.7499ZM14.8171 4.34632L5.56712 6.40187C5.00829 6.52606 4.72888 6.58815 4.52031 6.73841C4.33634 6.87094 4.19189 7.05102 4.10241 7.25936C4.00098 7.49556 4.00098 7.78179 4.00098 8.35425L4.00098 9.7499C4.00098 10.45 4.00098 10.8 4.13722 11.0674C4.25706 11.3026 4.44829 11.4938 4.68349 11.6137C4.95088 11.7499 5.30091 11.7499 6.00098 11.7499H24.501C25.201 11.7499 25.5511 11.7499 25.8185 11.6137C26.0537 11.4938 26.2449 11.3026 26.3647 11.0674C26.501 10.8 26.501 10.45 26.501 9.7499V8.35425C26.501 7.78179 26.501 7.49556 26.3995 7.25936C26.3101 7.05102 26.1656 6.87094 25.9816 6.73841C25.7731 6.58815 25.4937 6.52606 24.9348 6.40187L15.6848 4.34632C15.5229 4.31034 15.442 4.29235 15.3602 4.28517C15.2875 4.2788 15.2144 4.2788 15.1418 4.28517C15.06 4.29235 14.979 4.31034 14.8171 4.34632Z"
                                                    stroke="#E6B401"
                                                    stroke-width="2"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                            </svg>
                                        </div>
                                        <p class="fw-medium mb-0">Banking & Payments</p>
                                    </div>
                                    <div class="card-list-circle mb-2">
                                        <div class="rounded-img">
                                            <svg width="39"
                                                height="39"
                                                viewBox="0 0 39 39"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M13.626 10.1249C13.626 8.39899 15.0251 6.99988 16.751 6.99988C18.4769 6.99988 19.876 8.39899 19.876 10.1249V11.9999H21.126C22.8733 11.9999 23.7469 11.9999 24.436 12.2853C25.3549 12.6659 26.0849 13.396 26.4655 14.3148C26.751 15.004 26.751 15.8776 26.751 17.6249H28.626C30.3519 17.6249 31.751 19.024 31.751 20.7499C31.751 22.4758 30.3519 23.8749 28.626 23.8749H26.751V25.9999C26.751 28.1001 26.751 29.1502 26.3423 29.9523C25.9827 30.6579 25.409 31.2316 24.7034 31.5912C23.9013 31.9999 22.8512 31.9999 20.751 31.9999H19.876V29.8124C19.876 28.2591 18.6168 26.9999 17.0635 26.9999C15.5102 26.9999 14.251 28.2591 14.251 29.8124V31.9999H12.751C10.6508 31.9999 9.60068 31.9999 8.79851 31.5912C8.0929 31.2316 7.51923 30.6579 7.1597 29.9523C6.75098 29.1502 6.75098 28.1001 6.75098 25.9999V23.8749H8.62598C10.3519 23.8749 11.751 22.4758 11.751 20.7499C11.751 19.024 10.3519 17.6249 8.62598 17.6249H6.75098C6.75098 15.8776 6.75098 15.004 7.03643 14.3148C7.41703 13.396 8.14706 12.6659 9.06591 12.2853C9.75506 11.9999 10.6287 11.9999 12.376 11.9999H13.626V10.1249Z"
                                                    stroke="#E6B401"
                                                    stroke-width="2"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                            </svg>
                                        </div>
                                        <p class="fw-medium mb-0">Marketplace &
                                            Integrations</p>
                                    </div>
                                    <div class="card-list-circle mb-2">
                                        <div class="rounded-img">
                                            <svg width="31"
                                                height="31"
                                                viewBox="0 0 31 31"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M24.501 26.7499V19.2499M20.751 22.9999H28.251M15.751 19.2499H10.751C8.42127 19.2499 7.25641 19.2499 6.33756 19.6305C5.11242 20.1379 4.13905 21.1113 3.63158 22.3365C3.25098 23.2553 3.25098 24.4202 3.25098 26.7499M20.126 4.61333C21.9584 5.35506 23.251 7.15152 23.251 9.24988C23.251 11.3482 21.9584 13.1447 20.126 13.8864M17.626 9.24988C17.626 12.0113 15.3874 14.2499 12.626 14.2499C9.86455 14.2499 7.62598 12.0113 7.62598 9.24988C7.62598 6.48845 9.86455 4.24988 12.626 4.24988C15.3874 4.24988 17.626 6.48845 17.626 9.24988Z"
                                                    stroke="#E6B401"
                                                    stroke-width="2"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                            </svg>
                                        </div>
                                        <p class="fw-medium mb-0">Multiple Users
                                            & Entities</p>
                                    </div>
                                    <div class="card-list-circle mb-2">
                                        <div class="rounded-img">
                                            <svg width="31"
                                                height="31"
                                                viewBox="0 0 31 31"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M9.62598 14.2499H6.00098C5.30091 14.2499 4.95088 14.2499 4.68349 14.3861C4.44829 14.506 4.25706 14.6972 4.13722 14.9324C4.00098 15.1998 4.00098 15.5498 4.00098 16.2499V26.7499M20.876 14.2499H24.501C25.201 14.2499 25.5511 14.2499 25.8185 14.3861C26.0537 14.506 26.2449 14.6972 26.3647 14.9324C26.501 15.1998 26.501 15.5498 26.501 16.2499V26.7499M20.876 26.7499V8.24988C20.876 6.84975 20.876 6.14968 20.6035 5.6149C20.3638 5.1445 19.9814 4.76205 19.511 4.52236C18.9762 4.24988 18.2761 4.24988 16.876 4.24988H13.626C12.2258 4.24988 11.5258 4.24988 10.991 4.52236C10.5206 4.76205 10.1381 5.1445 9.89846 5.6149C9.62598 6.14968 9.62598 6.84975 9.62598 8.24988V26.7499M27.751 26.7499H2.75098M14.001 9.24988H16.501M14.001 14.2499H16.501M14.001 19.2499H16.501"
                                                    stroke="#E6B401"
                                                    stroke-width="2"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                            </svg>
                                        </div>
                                        <p class="fw-medium mb-0">Company Management</p>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex gap-3 align-items-center mt-3"
                                [ngClass]="{'justify-content-between': currentStep !== 1,
                                            'justify-content-end': currentStep === 1 }">
                                <button type="button"
                                    pmdRipple
                                    *ngIf="currentStep !== 1 "
                                    pmd-btn-outline
                                    class="pmd-btn-min"
                                    color="dark"
                                    (click)="goToBackStep()">
                                    Back
                                </button>
                                <div class="d-flex gap-3">
                                    <!-- <button type="button"
                                        pmdRipple
                                        pmd-btn-outline
                                        color="secondary"
                                        *ngIf="currentStep == 2"
                                        (click)="onSkip()"
                                        class="pmd-btn-outline-secondary">
                                        <span *ngIf="currentStep === 2">Skip For Now</span> -->
                                    <!-- <span *ngIf="currentStep === 3">Upgrade to Premium</span> -->

                                    <!-- <span *ngIf="isSkipping"
                                            class="spinner-border spinner-border-sm ms-1"
                                            role="status"
                                            aria-hidden="true"></span>
                                    </button> -->
                                    <button type="button"
                                        pmdRipple
                                        pmd-btn-raised
                                        class="pmd-btn-min"
                                        (click)="goToNextStep()"
                                        color="secondary">
                                        {{ currentStep !== 3 ? 'Next':'Start Free Trial'}}
                                        <span *ngIf="isSubmitting"
                                            class="spinner-border spinner-border-sm ms-1"
                                            role="status"
                                            aria-hidden="true"></span>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>